module.exports = "build/assets/RingsideCondensed-Semi.cf8f5099.woff";